module.exports = __webpack_public_path__ + "static/media/culture.ff86b297.jpg";